<!-- Campos del formulario (compartidos desktop modal / móvil página) -->
<ng-template #formFields>
    @if (isPaymentStep() || isResubmitObserve()) {
        @if (isReimbursement()) {
            <div class="mb-3">
                <label class="form-label fw-semibold">Destino del Reembolso</label>
                <div class="btn-group w-100" role="group">
                    <button type="button" class="btn btn-sm"
                        [class.btn-primary]="payTarget() === 'CAMPUS'"
                        [class.btn-outline-primary]="payTarget() !== 'CAMPUS'"
                        [disabled]="isProcessing()"
                        (click)="setPayTarget('CAMPUS')">
                        <i class="fas fa-university me-1"></i>Al Campo
                    </button>
                    <button type="button" class="btn btn-sm"
                        [class.btn-primary]="payTarget() === 'SOCIO'"
                        [class.btn-outline-primary]="payTarget() !== 'SOCIO'"
                        [disabled]="isProcessing()"
                        (click)="setPayTarget('SOCIO')">
                        <i class="fas fa-user me-1"></i>Al Socio
                    </button>
                </div>
            </div>
        }
        <div class="mb-3">
            <label class="form-label fw-semibold">Fecha de la transferencia</label>
            <input type="date" class="form-control form-control-sm"
                [value]="payDate()"
                (input)="onPayDateInput($event)"
                [disabled]="isProcessing()">
        </div>
    }

    @if (isCommissionStep()) {
        <div class="card bg-light border-0 mb-3 p-3">
            <div class="d-flex align-items-center mb-2 text-primary fw-semibold">
                <i class="fas fa-gavel me-2"></i>Aprobación de Comisión (Acta y Monto Tope)
            </div>
            <div class="small text-muted mb-3">
                Defina el porcentaje de deducible acordado y el monto tope máximo cubierto. La liquidación definitiva se calculará sobre la factura real.
            </div>
            <div class="row g-2">
                <div class="col-md-6">
                    <label class="form-label small fw-semibold">Deducible Aprobado (%)</label>
                    <div class="input-group input-group-sm">
                        <input type="number" class="form-control"
                            [value]="approvedDeductible()"
                            (input)="onApprovedDeductibleInput($event)"
                            min="0" max="100">
                        <span class="input-group-text">%</span>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="form-label small fw-semibold">Monto Tope Aprobado ($)</label>
                    <div class="input-group input-group-sm">
                        <span class="input-group-text">$</span>
                        <input type="number" class="form-control"
                            [value]="approvedAmount()"
                            (input)="onApprovedAmountInput($event)"
                            min="0">
                    </div>
                </div>
            </div>
        </div>
    }

    @if (isAwaitingInvoiceStep()) {
        <div class="card bg-light border-0 mb-3 p-3">
            <div class="d-flex align-items-center mb-2 text-success fw-semibold">
                <i class="fas fa-file-invoice-dollar me-2"></i>Factura / Boleta de Reparación
            </div>
            <div class="mb-3">
                <label class="form-label small fw-semibold">Monto Total de Factura / Boleta ($)</label>
                <div class="input-group">
                    <span class="input-group-text">$</span>
                    <input type="number" class="form-control form-control-lg fw-bold"
                        placeholder="Ej: 900000"
                        [value]="invoicedAmount() ?? ''"
                        (input)="onInvoicedAmountInput($event)">
                </div>
                <div class="form-text text-muted">Monto total emitido por el taller de reparación.</div>
            </div>

            @if (invoicedAmount() && invoicedAmount()! > 0) {
                <div class="p-2 rounded bg-white border small">
                    <div class="d-flex justify-content-between mb-1">
                        <span class="text-muted">Total Factura:</span>
                        <span class="fw-semibold">{{ invoicedAmount() | currency:'CLP':'symbol':'1.0-0' }}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-1 text-danger">
                        <span>Deducible ({{ effectiveDeductiblePct() }}%):</span>
                        <span>- {{ calculatedInvoiceDeductible() | currency:'CLP':'symbol':'1.0-0' }}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-1">
                        <span class="text-muted">Neto resultante:</span>
                        <span>{{ calculatedInvoiceNet() | currency:'CLP':'symbol':'1.0-0' }}</span>
                    </div>
                    @if (isCapApplied()) {
                        <div class="d-flex justify-content-between mb-1 text-warning">
                            <span>Tope Comisión:</span>
                            <span>{{ approvedCap() | currency:'CLP':'symbol':'1.0-0' }} (Aplica Tope)</span>
                        </div>
                    }
                    <hr class="my-1">
                    <div class="d-flex justify-content-between fw-bold text-success fs-6">
                        <span>Reembolso Final:</span>
                        <span>{{ finalReimbursementAmount() | currency:'CLP':'symbol':'1.0-0' }}</span>
                    </div>
                </div>
            }
        </div>
    }

    <div class="mb-3">
        <label class="form-label fw-semibold">{{ glossLabel() }}</label>
        <input type="text" class="form-control"
            [value]="gloss()"
            (input)="onGlossInput($event)"
            [disabled]="isProcessing()"
            [placeholder]="glossPlaceholder()"
            maxlength="100">
        @if (isLookingUpDoc()) {
            <div class="form-text text-muted"><i class="fas fa-spinner fa-spin me-1"></i>Buscando documento existente…</div>
        }
        @if (!isLookingUpDoc() && reusedDoc()) {
            <div class="form-text text-success"><i class="fas fa-check-circle me-1"></i>Documento registrado con esa glosa; se reutilizará el archivo.</div>
        }
        @if (!isLookingUpDoc() && hasDocInDb() && !reusedDoc()) {
            <div class="form-text text-success"><i class="fas fa-check-circle me-1"></i>Documento ya adjunto a esta solicitud.</div>
        }
        @if (!isLookingUpDoc() && needsFileUpload() && effectiveGloss()) {
            <div class="form-text text-muted">No existe archivo previo con esa glosa. Adjunte imagen o PDF.</div>
        }
    </div>

    @if (requiresDocument()) {
        <div class="mb-3">
            <label class="form-label fw-semibold">{{ fileSectionLabel() }}</label>
            <div class="d-flex align-items-center gap-2 flex-wrap">
                @if (hasDocInDb() || reusedDoc()) {
                    <button type="button" class="btn btn-outline-primary btn-sm"
                        (click)="viewDocument()"
                        [disabled]="!canViewPreview()">
                        <i class="fas fa-eye me-1"></i>Ver documento
                    </button>
                }
                <label class="btn btn-outline-secondary btn-sm mb-0"
                    [class.disabled]="isProcessing() || isOptimizingFile()">
                    <i class="fas fa-paperclip me-1"></i>
                    @if (isOptimizingFile()) {
                        Optimizando…
                    } @else {
                        {{ hasDocInDb() || reusedDoc() ? 'Reemplazar archivo' : 'Seleccionar archivo' }}
                    }
                    <input type="file" class="d-none" accept="image/*,.pdf"
                        [disabled]="isProcessing() || isOptimizingFile()"
                        (change)="onFileSelected($event)">
                </label>
                @if (fileName()) {
                    <span class="small text-muted text-truncate" style="max-width: 250px;">{{ fileName() }}</span>
                }
            </div>
        </div>

        <div class="step-modal-preview border rounded">
            @if (previewKind() === 'image' && previewImgUrl()) {
                <img [src]="previewImgUrl()" alt="Vista previa del documento" class="step-modal-preview-img">
            } @else if (previewKind() === 'pdf' && previewPdfUrl()) {
                <iframe [src]="previewPdfUrl()" title="Vista previa del documento" class="step-modal-preview-iframe"></iframe>
            } @else {
                <div class="text-muted text-center p-4 small">
                    <i class="far fa-file-alt fa-2x d-block mb-2 text-secondary"></i>
                    Sin archivo cargado
                </div>
            }
        </div>
    }

    @if (blockedReason()) {
        <div class="alert alert-warning py-2 px-3 small mt-3 mb-0">
            <i class="fas fa-exclamation-triangle me-1"></i>{{ blockedReason() }}
        </div>
    }
</ng-template>

<!-- Desktop: modal Ngb -->
<ng-template #approvalModal let-d="dismiss">
    <div class="modal-header border-bottom-0">
        <h5 class="modal-title fw-bold">
            <i class="fas fa-file-signature text-primary me-2" aria-hidden="true"></i>
            {{ modalTitle() }}
        </h5>
        <button type="button" class="btn-close" (click)="close()" [disabled]="isProcessing()"></button>
    </div>
    <div class="modal-body">
        <ng-container *ngTemplateOutlet="formFields"></ng-container>
    </div>
    <div class="modal-footer border-top-0">
        <button type="button" class="btn btn-white btn-sm" (click)="close()" [disabled]="isProcessing()">Cancelar</button>
        <button type="button" class="btn btn-primary btn-sm"
            (click)="confirm()"
            [disabled]="isProcessing() || isOptimizingFile() || !!blockedReason()">
            <i class="fas fa-check me-1"></i>
            {{ isProcessing() ? 'Procesando…' : confirmBtnLabel() }}
        </button>
    </div>
</ng-template>

<!-- Móvil: pantalla completa con page-header + panel + mobile-footer -->
@if (mobileOpen()) {
    <div class="step-approval-mobile-page" role="dialog" aria-modal="true">
        <app-page-header
            [title]="modalTitle()"
            [showBack]="true"
            [unifiedOnMobile]="true"
            (back)="close()">
        </app-page-header>

        <div class="step-approval-mobile-body">
            <div class="panel mb-0">
                <div class="step-body p-3">
                    <ng-container *ngTemplateOutlet="formFields"></ng-container>
                </div>
            </div>
        </div>

        <app-mobile-footer [visible]="true">
            <button type="button" class="btn btn-primary btn-sm w-100"
                (click)="confirm()"
                [disabled]="isProcessing() || isOptimizingFile() || !!blockedReason()">
                @if (isProcessing()) {
                    <span class="spinner-border spinner-border-sm me-1"></span>
                } @else {
                    <i class="fas fa-check me-1"></i>
                }
                {{ isProcessing() ? 'Procesando…' : confirmBtnLabel() }}
            </button>
        </app-mobile-footer>
    </div>
}
